import { isObject, type SimpleTradeSiteListItem, useApiTradeV1TradeSitesList } from 'api';
import { useState } from 'react';

import { AutocompleteField, type AutocompleteFieldProps } from '../AutocompleteField/AutocompleteField';

type Props = Omit<AutocompleteFieldProps<SimpleTradeSiteListItem>, 'options' | 'defaultValue'> & {
  defaultValue?: SimpleTradeSiteListItem['id'];
};

export const SiteAutocomplete = ({ required = false, defaultValue, ...rest }: Props) => {
  const [query, setQuery] = useState(defaultValue?.toString() || '');

  const { data, isLoading } = useApiTradeV1TradeSitesList({
    search: query,
  });

  return (
    <AutocompleteField<SimpleTradeSiteListItem>
      options={data?.results || []}
      loading={isLoading}
      getOptionLabel={(option) => {
        if (isObject(option) && option?.full_address) {
          return option.full_address;
        }
        return '';
      }}
      isOptionEqualToValue={(option, value) => {
        return value === undefined || option?.id?.toString() === (value?.id ?? value)?.toString();
      }}
      valueField="id"
      required={required}
      filterOptions={(options, state) => {
        setQuery(state.inputValue);
        return options;
      }}
      {...rest}
    />
  );
};
